// WSC legacy sets chosen language in `selectedLanguage` cookie.
// -1 is en-us, -24 is en-ca, -25 is fr-ca

export enum languageMap {
    'en-us' = -1,
    'fr-ca' = -25,
    'en-ca' = -24,
}
